var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaffTabActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Human Resources Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 2259",
    d: "M17.1142 8.95312H15.5674C15.729 9.38654 15.8114 9.84435 15.8108 10.3057V16.0211C15.811 16.2135 15.7776 16.4046 15.7118 16.586H18.2676C18.7269 16.5855 19.1671 16.4068 19.4919 16.0893C19.8166 15.7718 19.9993 15.3413 19.9999 14.8923V11.7766C19.9996 11.0282 19.6956 10.3106 19.1545 9.78117C18.6135 9.25179 17.8796 8.95399 17.1142 8.95312Z",
    fill: "#0C66E4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 2260",
    d: "M4.19028 10.3096C4.18966 9.84826 4.27203 9.39044 4.43363 8.95703H2.88908C2.12285 8.95703 1.388 9.2546 0.846193 9.78431C0.304385 10.314 0 11.0325 0 11.7816L0 14.8973C0.000588047 15.3463 0.183291 15.7768 0.50804 16.0943C0.832789 16.4118 1.27308 16.5904 1.73234 16.591H4.28807C4.22237 16.4096 4.18892 16.2185 4.18917 16.0261L4.19028 10.3096Z",
    fill: "#0C66E4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 865"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 2261",
    d: "M11.7686 7.48438H8.23282C7.46659 7.48438 6.73175 7.78196 6.18994 8.31167C5.64813 8.84139 5.34375 9.55982 5.34375 10.309V16.0244C5.34375 16.1742 5.40462 16.3179 5.51298 16.4239C5.62134 16.5298 5.76833 16.5893 5.92157 16.5893H14.0777C14.2309 16.5893 14.3779 16.5298 14.4862 16.4239C14.5946 16.3179 14.6555 16.1742 14.6555 16.0244V10.309C14.6555 9.5602 14.3514 8.84209 13.8101 8.31244C13.2688 7.78279 12.5345 7.48495 11.7686 7.48438Z",
    fill: "#0C66E4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 2262",
    d: "M10.0015 0C9.31502 0.00021487 8.64402 0.199415 8.07333 0.572419C7.50264 0.945422 7.05788 1.47548 6.79528 2.09558C6.53268 2.71568 6.46403 3.39798 6.59801 4.05622C6.73198 4.71446 7.06259 5.31909 7.548 5.79366C8.03341 6.26823 8.65183 6.59144 9.32511 6.72243C9.99838 6.85342 10.6963 6.7863 11.3305 6.52956C11.9648 6.27283 12.5069 5.838 12.8885 5.28005C13.27 4.7221 13.4737 4.06608 13.4739 3.39493C13.4731 2.49481 13.1069 1.63179 12.4559 0.995306C11.8049 0.358819 10.9222 0.000862881 10.0015 0Z",
    fill: "#0C66E4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 2263",
    d: "M3.90321 3.16406C3.38992 3.16428 2.88822 3.31327 2.46152 3.59221C2.03483 3.87115 1.7023 4.2675 1.50597 4.73118C1.30965 5.19485 1.25833 5.70502 1.35852 6.1972C1.45872 6.68938 1.70592 7.14148 2.06887 7.49633C2.43182 7.85118 2.89423 8.09285 3.39765 8.1908C3.90107 8.28876 4.4229 8.2386 4.89716 8.04665C5.37142 7.85471 5.77683 7.5296 6.06214 7.11243C6.34744 6.69526 6.49984 6.20476 6.50006 5.70293C6.49918 5.02984 6.2253 4.38457 5.73849 3.90863C5.25168 3.43268 4.59167 3.16492 3.90321 3.16406Z",
    fill: "#0C66E4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 2264",
    d: "M16.0988 3.16406C15.5852 3.16406 15.0831 3.31296 14.6561 3.59194C14.229 3.87091 13.8962 4.26743 13.6996 4.73134C13.5031 5.19526 13.4517 5.70574 13.5519 6.19824C13.6521 6.69073 13.8994 7.14311 14.2626 7.49817C14.6257 7.85324 15.0884 8.09505 15.5922 8.19301C16.0959 8.29097 16.618 8.24069 17.0925 8.04853C17.5671 7.85637 17.9726 7.53097 18.258 7.11345C18.5433 6.69594 18.6956 6.20507 18.6956 5.70293C18.6948 5.02984 18.4209 4.38457 17.9341 3.90863C17.4473 3.43268 16.7872 3.16492 16.0988 3.16406Z",
    fill: "#0C66E4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffTabActive);
export default __webpack_public_path__ + "static/media/staffTabActive.5fcffc192dc51f67761500d30be4362f.svg";
export { ForwardRef as ReactComponent };